/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {config} from "../../../AppConfig/config";

export const BASE_COVERAGE_REQUIREMENTS_ENDPOINT = '/HttpTriggerCoverageRequirements'

const coverageRequirementsHeaderTitle = 'Coverage Analysis'
const coverageRequirementsSidebarTitle = 'Coverage Analysis'
const coverageRequirementsLandingRoute = '/coverage-requirements'
const coverageRequirementsDetails = '/coveragerequirementsstudydetails'
const coverageRequirementsStudiesDataEndpoint = '/HttpTriggerGetDataCoreSQL?container=CoverageRequirementsStudies'
const coverageRequirementsDataEndpoint = '/HttpTriggerGetDataCoreSQL?container=CoverageRequirements'

const generateDatasetsEndpoint = `${config.url.API_URL}/orchestrators/DurableFunctionsRedlineOrchestrator`
const mergeDatasetsCreateEndpoint =  '/orchestrators/DurableFunctionsMergeDatasetsOrchestrator'
const mergeDatasetsUpdateEndpoint =  '/orchestrators/DurableFunctionsMergeDatasetsOrchestrator'

const usersDataEndpoint = '/HttpTriggerGetDataCoreSQL?container=Users'
const addNewStudyEndpoint = '/HttpTriggerAddNewCoverageRequirementStudy'
const editStudyEndPoint = '/HttpTriggerEditCoverageRequirementStudy'
const redlineDataSet = '/HttpTriggerGetDataCoreSQL?container=RedlineDatasets'

const checkRegenMergeEndpoint = `${BASE_COVERAGE_REQUIREMENTS_ENDPOINT}?request_operation=checkRegenMerge`
const updateOwnerEndpoint = `${BASE_COVERAGE_REQUIREMENTS_ENDPOINT}?request_operation=updateOwner`
const checkPlanOfRecordEndpoint = `${BASE_COVERAGE_REQUIREMENTS_ENDPOINT}?request_operation=checkPlanOfRecord`

const INITIAL_SELECTED_HORIZONTAL_TAB_INDEX = 0
const INITIAL_SELECTED_VERTICAL_TAB_INDEX = 0

export type DatasetType = "Single" | "Merged" | ""

export {
  coverageRequirementsHeaderTitle,
  coverageRequirementsSidebarTitle,
  coverageRequirementsLandingRoute,
  coverageRequirementsDetails,
  coverageRequirementsStudiesDataEndpoint,
  generateDatasetsEndpoint,
  mergeDatasetsCreateEndpoint,
  mergeDatasetsUpdateEndpoint,
  usersDataEndpoint,
  INITIAL_SELECTED_HORIZONTAL_TAB_INDEX,
  INITIAL_SELECTED_VERTICAL_TAB_INDEX, 
  addNewStudyEndpoint, 
  editStudyEndPoint,
  redlineDataSet,
  coverageRequirementsDataEndpoint,
  checkRegenMergeEndpoint,
  updateOwnerEndpoint,
  checkPlanOfRecordEndpoint,
}


export enum CoverageRequirementsRequestOperations {
  UPDATE = 'update',
  GET = 'get',

  CANCEL_RAW_REDLINE_RUNS = 'cancelRawRedlineRuns',
  FETCH_REDLINE_DATASETS_FOR_STUDY = 'fetchRedlineDatasetsForStudy',
  GET_ALL_STUDY_IDS = 'getAllStudyIds',
  GET_DATASETS_FOR_ALL_STUDIES = 'getDatasetsForAllStudies',
}

export enum CoverageRequirementsRequestTypes {
  SHOULD_DELETE_COVERAGE_REQUIREMENTS_STUDY = 'shouldDeleteCoverageRequirementsStudy',
  DELETE_COVERAGE_REQUIREMENTS_STUDY = 'deleteCoverageRequirementsStudy',
}

enum CoverageRequirementsRequestKeys {
  REQUEST_OPERATION = 'request_operation',
  REQUEST_TYPE = 'request_type',
}

export const formBaseCoverageRequirementsRequestUrl = (operation: CoverageRequirementsRequestOperations | null, type: CoverageRequirementsRequestTypes | null) => {
  let url = BASE_COVERAGE_REQUIREMENTS_ENDPOINT;
  let params = [];

  if(operation != null) {
    params.push(`${CoverageRequirementsRequestKeys.REQUEST_OPERATION}=${operation}`);
  }
  if(type != null) {
    params.push(`${CoverageRequirementsRequestKeys.REQUEST_TYPE}=${type}`);
  }

  if(params.length > 0) {
    url += '?' + params.join('&');
  }

  return url;
}
export const COVERAGE_REQUIREMENTS_CONSTANTS = {
  landing: {
    endpoints: {
      deleteCoverageRequirementsStudy: formBaseCoverageRequirementsRequestUrl(CoverageRequirementsRequestOperations.UPDATE, CoverageRequirementsRequestTypes.DELETE_COVERAGE_REQUIREMENTS_STUDY),
      shouldDeleteCoveragerequirementsStudy: formBaseCoverageRequirementsRequestUrl(CoverageRequirementsRequestOperations.UPDATE, CoverageRequirementsRequestTypes.SHOULD_DELETE_COVERAGE_REQUIREMENTS_STUDY),
    }
  },
  details: {
    endpoints: {
      cancelRawRedlineRuns: formBaseCoverageRequirementsRequestUrl(CoverageRequirementsRequestOperations.CANCEL_RAW_REDLINE_RUNS, null),
      fetchRedlineDatasetsForStudy: formBaseCoverageRequirementsRequestUrl(CoverageRequirementsRequestOperations.FETCH_REDLINE_DATASETS_FOR_STUDY, null),
    }
  }
}
